var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBeta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.745 6.397c-.15-.188.03-.452.26-.387 3.317.932 5.483 2.473 5.483 4.221 0 2.85-5.77 5.158-12.889 5.158-4.643 0-8.71-.985-10.98-2.458-.18-.119-.069-.402.146-.36 1.714.341 3.642.53 5.681.53 7.12 0 12.889-2.31 12.889-5.158 0-.536-.207-1.058-.59-1.545zm2.542 8.987c-.172-.218.039-.529.307-.452 3.876 1.089 6.41 2.89 6.406 4.93 0 3.324-6.743 6.023-15.062 6.023-5.424 0-10.182-1.15-12.83-2.871-.215-.138-.081-.468.168-.418 2 .395 4.255.617 6.64.617 8.318 0 15.062-2.695 15.062-6.023 0-.629-.242-1.235-.69-1.806z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeta);
export default __webpack_public_path__ + "static/media/BETA.3dc7bff32e1094f7a424bd7cded61b02.svg";
export { ForwardRef as ReactComponent };